import SiafLiteApiRepository from "../../external/siafLiteApi";

class EnquadramentoLegalService {
  constructor() {
    this.urlBase = "/fiscal/enquadramentos-legais";
    this.urlBaseEvent = `/event${this.urlBase}`;
  }

  getAll() {
    return new SiafLiteApiRepository(this.urlBaseEvent).get();
  }
}

export default EnquadramentoLegalService;
